import objectUtils from '../../utils/object-utils'
import { generateStore } from './store'

const pluginName = 'client-auth-support'
const defaultNamespace = 'auth'
const defaultPageHome = 'home'
const defaultUnAuthedTo = 'login'

export default function install (Vue, options = {}) {
  // Parse options...
  const logInit = options.logInit && options.logInit === true
  const debug = options.debug && options.debug === true
  const namespace = options.namespace || defaultNamespace
  const authenticator = options.authenticator
  const includeUserInfo = options.includeUserInfo && options.includeUserInfo === true
  const pageHome = options.pageHome || defaultPageHome
  const directUnAuthedTo = options.directUnAuthedTo || defaultUnAuthedTo

  if (logInit) console.log(`Vue is being bootstrapped with "${pluginName}", using namespace: ${namespace}`)

  // Bootstrap vuex with auth session management
  if (options.store) {
    const authSessionStore = generateStore({
      debug,
      pluginName,
      authenticator,
      includeUserInfo
    })
    options.store.registerModule(namespace, authSessionStore)

    // Bootstrap vue-router with validate hook
    if (options.router) {
      options.router.beforeEach(async (to, from, next) => {
        // Permit authHandler logout hook
        if (to.matched.some(record => record.meta.authLogout)) {
          // console.log('[DEVING] auth handler:', to)
          // next()
        // Otherwise, validate session and honor protected routes
        } else {
          const sessionInfo = await options.store.dispatch(`${namespace}/validateSession`)
          // -------------------
          // Auth required pages
          // -------------------
          if (to.matched.some(record => record.meta.requiresAuth)) {
            // Ensure active org audience (ui type) is permitted
            const supportedOrgTypes = to.meta.ui_type
            const activeOrg = options.store.getters['auth/activeOrg']
            const orgType = activeOrg?.org_type_code
            let isPermitted = sessionInfo.is_authenticated
            if (supportedOrgTypes) {
              isPermitted = objectUtils.includes(supportedOrgTypes, orgType)
            }
            if (!isPermitted && to.name !== directUnAuthedTo) {
              next({ name: directUnAuthedTo })
            } else {
              next()
            }
          // ------------
          // Public pages
          // ------------
          } else {
            if (to.name === directUnAuthedTo && sessionInfo.is_authenticated) {
              next({ name: pageHome }) // block login page when authed
            } else {
              next()
            }
          }
        }
      })
    } // end-if (options.router)
  } // end-if (options.store)
}
